import Clipboard from 'clipboard';
import Vue from 'vue';

/**
 * 快捷指令在DOM/组件对象上添加点击复制文本信息(支持HTML)
 * 使用方式:	v-copy="'文本内容(复制成功或失败时都会有提示)'" 或 v-copy.success="'复制成功时才有提示'" 或 v-copy.error="'复制失败时才有提示'"
 * 其它可添加辅助项:	data-clipboard-success="复制成功时的提示信息"
 * 其它可添加辅助项:	data-clipboard-error="复制失败时的提示信息"
 * 注意: 如果在该DOM/组件对象上添加@clip="handler"时,将不触发提示信息, 请在handler中根据e.success或e.error自行处理.
 */

export default {
	bind (el: HTMLElement, binding: any, vnode: any) {
		const handler = vnode.componentInstance
			? (vnode.componentInstance.$listeners || {}).clip
			: ((vnode.data || {}).on || {}).clip;
		if (el.dataset) {
			el.dataset.clipboardText = binding.value;
		} else {
			el.setAttribute('data-clipboard-text', binding.value);
		}
		let clipboard: any = new Clipboard(el, {
			text:
				function (trigger: HTMLElement){
					return trigger.getAttribute('data-clipboard-text');
				},
		});
		clipboard.on('success', function (e: any){
			if (handler && handler.fns) {
				handler.fns({ success: true, error: false });
				return;
			}
			const dataset = el.dataset;
			const successMessage = dataset ? dataset.clipboardSuccess : el.getAttribute('data-clipboard-success');
			if (binding.modifiers.success || (!binding.modifiers.success && !binding.modifiers.error)) {
				Vue.prototype.$message({
					type: 'success',
					message: successMessage || '复制成功!',
					dangerouslyUseHTMLString: true,
				});
			}
		});

		clipboard.on('error', function (e: any){
			if (handler && handler.fns) {
				handler.fns({ success: false, error: true });
				return;
			}
			const dataset = el.dataset;
			const errorMessage = dataset ? dataset.clipboardError : el.getAttribute('data-clipboard-error');
			if (binding.modifiers.error || (!binding.modifiers.success && !binding.modifiers.error)) {
				Vue.prototype.$message({
					type: 'error',
					message: errorMessage || '复制失败!',
					dangerouslyUseHTMLString: true,
				});
			}
		});
	},
	update (el: HTMLElement, binding: any) {
		if (el.dataset) {
			el.dataset.clipboardText = binding.value;
		} else {
			el.setAttribute('data-clipboard-text', binding.value);
		}
	},
	unbind (el: HTMLElement, binding: any) {},
};
